import { Box, Card, CardContent, Typography, Button, Alert } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useAuthContext } from './AuthContext';

export function AccessDeniedPage() {
  const { account, logout } = useAuthContext();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 480 }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Lock sx={{ fontSize: 56, color: 'error.main', mb: 2 }} />
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Access Denied
          </Typography>
          <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
            {account?.email
              ? `Your account ${account.email} has not been granted access to Beacon Platform.`
              : 'Your account has not been granted access to Beacon Platform.'}
          </Alert>
          <Typography variant="body2" color="text.secondary" mb={3}>
            Please contact your administrator to request access.
          </Typography>
          <Button variant="outlined" onClick={() => void logout()}>
            Sign out
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
